import React from 'react';
import { useTranslation } from 'react-i18next';
import { Menu, MenuItem } from '@mui/material';
import { useStyles } from '../styles';
import { SortType } from '../types';

interface SortMenuProps {
  anchorEl: null | HTMLElement;
  onClose: () => void;
  onSortChange: (sortType: SortType) => void;
  sortType?: SortType;
}

export const SortMenu: React.FC<SortMenuProps> = ({ anchorEl, onClose, onSortChange, sortType }) => {
  const { t } = useTranslation();
  const classes = useStyles();

  const handleSortItemClick = (sortType: SortType) => {
    onSortChange(sortType);
    onClose();
  };

  return (
    <Menu
      anchorEl={anchorEl}
      open={Boolean(anchorEl)}
      onClose={onClose}
      className={classes.sortMenu}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'left',
      }}
    >
      <MenuItem
        data-testid="project-sort-name-asc"
        onClick={() => handleSortItemClick(SortType.NAME_ASC)}
        className={classes.menuItem}
        selected={sortType === SortType.NAME_ASC}
      >
        {t('projectList.sort.nameAtoZ')}
      </MenuItem>
      <MenuItem
        data-testid="project-sort-name-desc"
        onClick={() => handleSortItemClick(SortType.NAME_DESC)}
        className={classes.menuItem}
        selected={sortType === SortType.NAME_DESC}
      >
        {t('projectList.sort.nameZtoA')}
      </MenuItem>
      <MenuItem
        data-testid="project-sort-date-asc"
        onClick={() => handleSortItemClick(SortType.DATE_ASC)}
        className={classes.menuItem}
        selected={sortType === SortType.DATE_ASC}
      >
        {t('projectList.sort.dateOldToNew')}
      </MenuItem>
      <MenuItem
        data-testid="project-sort-date-desc"
        onClick={() => handleSortItemClick(SortType.DATE_DESC)}
        className={classes.menuItem}
        selected={sortType === SortType.DATE_DESC}
      >
        {t('projectList.sort.dateNewToOld')}
      </MenuItem>
    </Menu>
  );
};
